module.exports = __webpack_public_path__ + "img/manual7.4d8d994b.png";